import DownloadSettings from './DownloadSettings'
import DownloadMultipleSettings from './DownloadMultipleSettings'
import DownloadStatistics from './DownloadStatistics'

import AddFullScreenView from './AddFullScreenView'
import EditFullScreenView from './EditFullScreenView'
import FullScreenSystem from './FullScreenSystem'
import UploadFileModal from './UploadFile'

import AddSystemModal from './AddSystemModal'
import EditSystemModal from './EditSystemModal'

import EditSystemLights from './EditSystemLights'
import EditSystemPeriodicity from './EditSystemPeriodicity'
import EditSystemCalibrationCo2 from './EditSystemCalibrationCo2'

import AddParameterAlertModal from './AddParameterAlertModal'
import AddInactivityAlertModal from './AddInactivityAlertModal'
import EditParameterAlertModal from './EditParameterAlertModal'
import EditInactivityAlertModal from './EditInactivityAlertModal'

import NewGroupModal from './NewGroup'
import EditGroupModal from './EditGroup'

import TypeInfoModal from './TypeInfoModal'
import SupportModal from './SupportModal'
import WhatIsNewModal from './WhatIsNewModal'
import AddReportModal from './AddReportModal'
import ConfirmationModal from './ConfirmationModal'
import DownloadWellDataReport from './DownloadWellDataReport'
import DownloadWellStaticData from './DownloadWellStaticData'
import AddCollaborativeModal from './AddCollaborativeModal'
import ShowMessage from './ShowMessage'
import ReportCalibrationModal from './ReportCalibrationModal'
import WeatherModal from './WeatherModal'
import MapModal from './MapModal'
import AddProjectModal from './AddProjectModal'
import ShareProjectModal from './ShareProjectModal'
import EditProjectModal from './EditProjectModal'
import ManageTrustedUsersModalContainer from './ManageTrustedUsers'
import deleteDevicesContainer from './DeleteDevices'
import ManageDevicesModalContainer from './ManageDevices'
import NewApiKey from './NewApiKey'
import DownloadKeys from './DownloadKeys'
import ApiKeysCreated from './ApiKeysCreated'
import RegenerateKey from './RegenerateKey'
import DeleteKey from './DeleteKey'
import AvailableKeys from './AvailableKeys'
import RelatedItemsModal from './RelatedItemsModal'

import ProjectInformation from './ProjectInformation'

export default {
  AddProjectModal,
  FullScreenSystem,
  ConfirmationModal,
  DownloadSettings,
  DownloadMultipleSettings,
  DownloadStatistics,
  AddSystemModal,
  EditSystemModal,
  EditSystemLights,
  EditSystemPeriodicity,
  AddParameterAlertModal,
  AddInactivityAlertModal,
  EditParameterAlertModal,
  EditInactivityAlertModal,
  AddFullScreenView,
  EditFullScreenView,
  NewGroupModal,
  EditGroupModal,
  UploadFileModal,
  TypeInfoModal,
  SupportModal,
  WhatIsNewModal,
  AddReportModal,
  DownloadWellDataReport,
  DownloadWellStaticData,
  AddCollaborativeModal,
  EditSystemCalibrationCo2,
  ShowMessage,
  ReportCalibrationModal,
  WeatherModal,
  MapModal,
  ShareProjectModal,
  EditProjectModal,
  ManageTrustedUsersModalContainer,
  deleteDevicesContainer,
  ManageDevicesModalContainer,
  NewApiKey,
  DownloadKeys,
  ApiKeysCreated,
  RegenerateKey,
  DeleteKey,
  AvailableKeys,
  RelatedItemsModal,
  ProjectInformation
}
